import { render, staticRenderFns } from "./MannerScore.vue?vue&type=template&id=74e05c8c&"
import script from "./MannerScore.vue?vue&type=script&lang=js&"
export * from "./MannerScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports